
<script>
/* global $ */
import NumbersPage from '../numbers-page/App.vue';
import NumbersGroup from './components/NumbersGroup.vue';

export default {
    components: {
        NumbersGroup
    },
    name: "NumbersPageBlock",
    extends: NumbersPage,
    data () {
        return {
            activeNumberGroup: [0],
            titleClass: '',
        }
    },
    methods: {
        toggleActive(i) {
            let index = this.activeNumberGroup.indexOf(i);
            if (index === -1) {
                this.activeNumberGroup.push(i);
            } else {
                this.activeNumberGroup = this.activeNumberGroup.filter((num) => {return num !== i});
            }
            $(window).resize();
        }
    }
}
</script>

<style lang="scss">

</style>